export const PROVIDERS = [
    {
        id: "chatgpt",
        label: "OpenAI ChatGPT",
        models: [
            { id: "gpt-5-mini", label: "GPT-5 Mini" },
            { id: "chatgpt-thinking", label: "Chat-5 Thinking" },
            { id: "chatgpt-omni", label: "Chat-5 Omni" },
        ],
    },
    {
        id: "claude",
        label: "Claude",
        models: [
            { id: "claude-haiku-4-5", label: "Haiku 4.5" },
            { id: "claude-sonnet-4-5", label: "Sonnet 4.5" },
            { id: "claude-opus", label: "Opus 4.1" },
        ],
    },
    {
        id: "gemini",
        label: "Gemini",
        models: [
            { id: "gemini-2.5-flash", label: "Gemini 2.5 Flash" },
            { id: "gemini-2.5-pro", label: "Gemini 2.5 Pro" },
        ],
    },
    {
        id: "perplexity",
        label: "Perplexity",
        models: [
            { id: "sonar", label: "Perplexity Sonar" },
            { id: "sonar-reasoning", label: "Perplexity Sonar Reasoning" },
        ],
    },
];
